import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const MailOpenFill = memo((props: IconProps) => {
    const { color = "#0E0E0E", ...rest } = props
    return (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...rest}>
            <path
                d="M2.243 6.854L11.49 1.31C11.6454 1.21675 11.8233 1.16749 12.0045 1.16749C12.1857 1.16749 12.3636 1.21675 12.519 1.31L21.757 6.855C21.8311 6.89942 21.8925 6.96228 21.9351 7.03747C21.9776 7.11265 22 7.19759 22 7.284V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V7.283C1.99998 7.19659 2.02236 7.11165 2.06495 7.03647C2.10753 6.96128 2.16888 6.89842 2.243 6.854ZM18.346 8.244L12.061 13.683L5.647 8.238L4.353 9.762L12.073 16.317L19.654 9.757L18.346 8.244V8.244Z"
                fill={color}
            />
        </svg>
    )
})

export default MailOpenFill
